import React from "react";
import { t } from "ttag";

import type {
    CenterFocusedSlidesBlock,
    CenterFocusedCarouselBlock as Value,
} from "@reactivated";

import {
    StreamField,
    type StreamFieldBlockMap,
} from "@thelabnyc/thelabui/src/components/StreamField";

import { Themed } from "../../styles/themes";
import { CenterFocusedCarousel } from "../CenterFocusedCarousel";
import { RichTextStreamBlock } from "../RichTextStreamBlock";
import { SpacerBlock } from "../SpacerBlock";

const Slides = ({ value }: { value: CenterFocusedSlidesBlock }) => {
    const slides = value.slides ?? [];
    if (slides.length === 0) return null;

    const resolved = slides.flatMap((slide, index) => {
        if (!slide.image) return [];
        return {
            id: index,
            url: slide.image.url,
            alt: slide.image.default_alt_text || slide.image.title,
            caption: slide.caption,
        };
    });

    return (
        <CenterFocusedCarousel
            label={value.block_label ?? t`Image carousel`}
            images={resolved}
            caption={(activeIndex) => {
                const caption = resolved[activeIndex]?.caption;
                if (!caption) return null;
                return <RichTextStreamBlock value={caption} />;
            }}
        />
    );
};

export const CenterFocusedCarouselBlock = ({ value }: { value: Value }) => {
    if (!value.items) return null;

    const components: StreamFieldBlockMap<NonNullable<Value["items"]>> = {
        spacer: SpacerBlock,
        slides: Slides,
    };

    return (
        <Themed theme={value.theme} tag="section">
            <StreamField
                tagName={React.Fragment}
                components={components}
                value={value.items}
            />
        </Themed>
    );
};
